<template>
    <span :id="'fullscreenNotification'+uuid">
        <sweet-modal :ref="uuid" overlay-theme="light" v-on:close="closeHandler"> 
            <div class="slot-content" v-html="notifContent"></div>
            <div v-if="notObj.richiediConferma || notObj.eliminabile" slot="button" style="background-color: white; border-top: none; text-align: right;"> <!--position:absolute; right: 40px; bottom: 20px;-->
                <button v-if="notObj.richiediConferma" class="btn btn-primary-default" style="margin-right: 30px;" @click.prevent="Ycallback">{{vi.Jed.firstUpperTranslate('Ok')}}</button>
                <button v-if="notObj.eliminabile" class="btn btn-danger" @click.prevent="Ncallback">{{vi.Jed.firstUpperTranslate('Delete')}}</button>
            </div>
        </sweet-modal>
    </span>
</template>
<script>

import { SweetModal } from "sweet-modal-vue";
import { eventBus } from "../../../eventbus.js"

export default {
    props: {
        vi: Object,
        closeModal: {
            type: Function,
            default() {
                return null;
            }
        },
        notifContent: String,
        uuid: String,
        notObj: Object
    },
    components: {
        SweetModal
    },
    mixins: [],
    mounted: function(){
        var vm = this;
        this.$nextTick(function(){
            this.$emit("API", { open: this.$refs[this.uuid].open, close: this.$refs[this.uuid].close })
        });
        this.vi.$root.fsinstances.push(this)
    },
    data: function() {
        return {}
    },
    methods: {
        closeHandler: function(){ 
            this.closeModal();
        },
        Ycallback: function(){
            this.$refs[this.uuid].close() //chiudo semplicemente il modal
        },
        Ncallback: function(){
            var vm = this;
            console.log(vm.vi.dataReferences.getCollection("userNotifications"))
            console.log(vm.notObj)
            /*var ok = function(){*/
                vm.vi.dataReferences.getCollection("userNotifications").remove(vm.notObj);
                eventBus.$emit("notificationLoop",vm.vi.dataReferences.getCollection("userNotifications").data.length);
                vm.$refs[vm.uuid].close()
            /*},
            no = function(){
                vm.$refs[vm.uuid].close()
            },
            e = {
                message: this.vi.Jed.firstUpperTranslate('Do you want to delete the notification?'), 
                ok: ok,
                no: no
            }
            eventBus.$emit("confirm", e)*/ 
            this.closeModal();
        }
    }
}
</script>

<style>

div.theme-light div.sweet-title {
    color: white; 
    background-color: #3c8dbc;
}

.sweet-modal .sweet-box-actions .sweet-action-close {
    color: #222C38 !important
}

[id^='fullscreenNotification'] .sweet-modal-overlay .sweet-modal{ /*scrollbar solo se lo schermo diventa più piccolo*/
    width: 90%;
    max-width: none;
    overflow-y: auto;
}

@media (max-height: 550px){ /*as long as the screen height is under 550px, the window notification is smaller*/
    [id^='fullscreenNotification'] .sweet-modal-overlay .sweet-modal{
      max-height: 400px;
    }
  }

</style>

<style scoped>
.sweet-modal-overlay {
    z-index: 999999
}

.sweet-content{
    padding: 32px 64px !important
}
</style>


// WEBPACK FOOTER //
// src/components/dynamic/modalWrapper/FullscreenNotification.vue?0acb0376